import { render, staticRenderFns } from "./ImagesThumbnail.vue?vue&type=template&id=cbf83afa&scoped=true&"
import script from "./ImagesThumbnail.vue?vue&type=script&lang=js&"
export * from "./ImagesThumbnail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf83afa",
  null
  
)

export default component.exports